import { render } from "./ProjectSectionFrameworks.vue?vue&type=template&id=632e2caf&scoped=true"
import script from "./ProjectSectionFrameworks.vue?vue&type=script&lang=js"
export * from "./ProjectSectionFrameworks.vue?vue&type=script&lang=js"

import "./ProjectSectionFrameworks.vue?vue&type=style&index=0&id=632e2caf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632e2caf"]])

export default __exports__